import React, {Fragment} from 'react';
import {bool, func, object, string} from 'prop-types';
import {Menu} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {NavLink, Route, Switch} from 'react-router-dom';
import {
    UserChallengesPage,
    UserOverviewPage,
    UserPointsPage,
    UserRafflesPage,
    UserStorePage,
    UserBadgesPage
} from './tabPanes';

const UserDetailNav = props => (
  <Fragment>
    <Menu tabular>
      <Menu.Item
        as={NavLink}
        exact
        to={`/user/${props.currentUserId}`}
        content={<FormattedMessage id='userManagement.userDetail.nav.overview' />}
        activeClassName='active' />
      <Menu.Item
        as={NavLink}
        to={`/user/${props.currentUserId}/breaks`}
        content={<FormattedMessage id='userManagement.userDetail.nav.challenges' />}
        activeClassName='active' />
      <Menu.Item
        as={NavLink}
        to={`/user/${props.currentUserId}/sweeps`}
        content={<FormattedMessage id='userManagement.userDetail.nav.raffles' />}
        activeClassName='active' />
      <Menu.Item
        as={NavLink}
        to={`/user/${props.currentUserId}/store`}
        content={<FormattedMessage id='userManagement.userDetail.nav.store' />}
        activeClassName='active' />
      <Menu.Item
        as={NavLink}
        to={`/user/${props.currentUserId}/points`}
        content={<FormattedMessage id='userManagement.userDetail.nav.points' />}
        activeClassName='active' />
      <Menu.Item
        as={NavLink}
        to={`/user/${props.currentUserId}/badges`}
        content={<FormattedMessage id='userManagement.userDetail.nav.badges' />}
        activeClassName='active' />
    </Menu>
    <Switch>
      <Route
        render={() => (
          <UserOverviewPage
            isLoading={props.loadingUserProfile}
            ajaxError={props.failedUserProfile}
            userGroupName={props.userGroupName}
            user={props.user}
            loggedInUser={props.loggedInUser} />
        )}
        exact
        path={`/user/${props.currentUserId}`} />
      <Route
        render={() => (
          <UserChallengesPage
            isLoading={props.loadingStartsCompletes}
            ajaxError={props.failedStartsCompletes}
            startsCompletes={props.user ? props.user.startsCompletes : []} />
        )}
        path={`/user/${props.currentUserId}/breaks`} />
      <Route
        render={() => (
          <UserRafflesPage
            isLoading={props.loadingRaffleEntries}
            ajaxError={props.failedRaffleEntries}
            raffleEntries={props.user ? props.user.raffleEntries : []} />
        )}
        path={`/user/${props.currentUserId}/sweeps`} />
      <Route
        render={() => <UserStorePage />}
        path={`/user/${props.currentUserId}/store`} />
      <Route
        render={() => (
          <UserPointsPage
            isLoading={props.loadingPointHistory}
            ajaxError={props.failedPointHistory}
            user={props.user}
            canCancelPoints={props.canCancelPoints}
            revokePoints={props.revokePoints} />
        )}
        path={`/user/${props.currentUserId}/points`} />
      <Route
        render={() => (
          <UserBadgesPage
            isLoading={props.loadingUserProfile}
            ajaxError={props.failedUserProfile}
            user={props.user} />
        )}
        path={`/user/${props.currentUserId}/badges`}/>
    </Switch>
  </Fragment>
);

UserDetailNav.propTypes = {
  user: object.isRequired,
  canCancelPoints: bool.isRequired,

  currentUserId: string.isRequired,
  revokePoints: func.isRequired,

  loadingUserProfile: bool.isRequired,
  failedUserProfile: object,

  loadingStartsCompletes: bool.isRequired,
  failedStartsCompletes: object,

  loadingRaffleEntries: bool.isRequired,
  failedRaffleEntries: object,

  loadingPrizeboothOrders: bool.isRequired,
  failedPrizeboothOrders: object,

  loadingPointHistory: bool.isRequired,
  failedPointHistory: object
};

export default UserDetailNav;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/UserDetailNav.jsx